import { render } from "./HistoricalSales.vue?vue&type=template&id=5e7cb661&scoped=true"
import script from "./HistoricalSales.vue?vue&type=script&lang=js"
export * from "./HistoricalSales.vue?vue&type=script&lang=js"

import "./HistoricalSales.vue?vue&type=style&index=0&id=5e7cb661&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e7cb661"]])

export default __exports__